import { Avatar } from '@mui/material';
import * as api from "api/Core";
import { ReactAutoComplete, ReactAutoCompleteProps } from 'components/AutoComplete';
import { UserShortView } from 'models/ApiModels';
import * as React from 'react';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps extends Omit<ReactAutoCompleteProps, "selectedItems" | "onGetSuggestions" | "onChange"> {
    refUserId: string;
    selectedItems?: UserShortView[];
    onChange: (data: UserShortView[]) => void;
}

type Props = IProps;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default class ManagerAutoComplete extends React.Component<Props, IState> {

    private apiGetData = api.getManagerSuggestions();

    static defaultProps: Partial<IProps> = {
        autoFocus: false,
        readonly: false,
        refUserId: null
    };

    private getSuggestions(searchText: string, skipRecords: number, takeRecords: number): Promise<AutoCompleteDataModel[]> {
        const inputValue = searchText.trim().toLowerCase();
        return this.apiGetData.execute({ searchText: inputValue, refUserId: this.props.refUserId, offset: skipRecords, take: takeRecords });
    }

    private handleUpdateSelection = (items: AutoCompleteDataModel[]) => {
        this.props.onChange(
            items.length == 0
                ? null
                : items.map((item) => ({ id: item.key, name: item.label, thumbnailUrl: item.thumbnailUrl } as UserShortView))
        );
    };

    private handleResolveAvatar(item: AutoCompleteDataModel) {
        return item.thumbnailUrl ? <Avatar src={item.thumbnailUrl} /> : null;
    }

    public render() {
        const { selectedItems } = this.props;
        return (
            <ReactAutoComplete
                {...this.props}
                selectedItems={selectedItems == null ? null : selectedItems.map((v) => ({ key: v.id, label: v.name, thumbnailUrl: v.thumbnailUrl, canDelete: true }))}
                onGetSuggestions={(searchText, skipRecords, takeRecords) => this.getSuggestions(searchText, skipRecords, takeRecords)}
                onChange={this.handleUpdateSelection}
                onResolveAvatar={(item) => this.handleResolveAvatar(item)}
            />
        );
    }
}